import { FileTextOutlined } from '@ant-design/icons';
import { List, PageHeader } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { NavLink } from 'react-router-dom';

export function ReportsPage() {
  const reports = [
    {
      title: 'Bölüm - risk bildirimi raporu',
      link: '/reports/report-1',
      description: 'Her bölüm için bildirilen risk sayıları sayıları raporu',
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <FileTextOutlined /> Raporlar
          </>
        }
      />
      <Content>
        <List
          dataSource={reports}
          renderItem={report => (
            <List.Item>
              <List.Item.Meta title={<NavLink to={report.link}>{report.title}</NavLink>} description={report.description} />
            </List.Item>
          )}
        />
      </Content>
    </>
  );
}
